import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { AppConstants } from 'src/app/core/constants';

@Component({
  selector: 'app-comparison-table',
  templateUrl: './comparison-table.component.html',
  styleUrls: ['./comparison-table.component.scss',],
})
export class ComparisonTableComponent {

  comparisonTable = [
    {
      header: {
        bodyType: 'Hatchback',
      },
      table: [
        { label: 'Market Price', leaseCol: 'true', loanCol: '₹6,50,000', },
        { label: 'Down payment (20%)', leaseCol: 'true', loanCol: '₹1,30,000', },
        { label: 'EMI (monthly)', leaseCol: 'true', loanCol: '₹-46,934', },
        { label: 'Opportunity Cost on Down Payment (10%)', leaseCol: 'true', loanCol: '₹9,100', },
        { label: 'Insurance (ZERO DEP + Hydrostatic Cover)', leaseCol: 'true', loanCol: '₹32,000', },
        { label: 'Service & Maintenance', leaseCol: 'true', loanCol: '₹45,980', },
        { label: 'Resale Value', leaseCol: 'Factored-in', loanCol: '₹39,000', },
        { label: 'GST', leaseCol: 'true', loanCol: 'NA', },
        { label: 'Monthly Lease Cost', leaseCol: '₹30,206', loanCol: '-', },
        { label: 'Tax Benefit (30%)', leaseCol: '₹9,062', loanCol: '-', },
        { label: 'Driver & Fuel Allowance Tax Benefit', leaseCol: '₹12,000', loanCol: '-', },
        { label: 'Monthly Cost', leaseCol: '₹9,144', loanCol: '₹32,524', },
      ],
      footer: {
        footerLine: '71.9%',
      },
    },
    {
      header: {
        bodyType: 'Sedan',
      },
      table: [
        { label: 'Market Price', leaseCol: 'true', loanCol: '₹10,75,000', },
        { label: 'Down payment (20%)', leaseCol: 'true', loanCol: '₹2,15,000', },
        { label: 'EMI (monthly)', leaseCol: 'true', loanCol: '₹-77,622', },
        { label: 'Opportunity Cost on Down Payment (10%)', leaseCol: 'true', loanCol: '₹15,050', },
        { label: 'Insurance (ZERO DEP + Hydrostatic Cover)', leaseCol: 'true', loanCol: '₹43,744', },
        { label: 'Service & Maintenance', leaseCol: 'true', loanCol: '₹41,544', },
        { label: 'Resale Value', leaseCol: 'Factored-in', loanCol: '₹6,66,500', },
        { label: 'GST', leaseCol: 'true', loanCol: 'NA', },
        { label: 'Monthly Lease Cost', leaseCol: '₹47,102', loanCol: '-', },
        { label: 'Tax Benefit (30%)', leaseCol: '₹14,131', loanCol: '-', },
        { label: 'Driver & Fuel Allowance Tax Benefit', leaseCol: '₹12,000', loanCol: '-', },
        { label: 'Monthly Cost', leaseCol: '₹20,971', loanCol: '₹48,359', },
      ],
      footer: {
        footerLine: '56.6%',
      },
    },
    {
      header: {
        bodyType: 'SUV',
      },
      table: [
        { label: 'Market Price', leaseCol: 'true', loanCol: '₹12,16,000', },
        { label: 'Down payment (20%)', leaseCol: 'true', loanCol: '₹2,43,200', },
        { label: 'EMI (monthly)', leaseCol: 'true', loanCol: '₹-87,803', },
        { label: 'Opportunity Cost on Down Payment (10%)', leaseCol: 'true', loanCol: '₹17,024', },
        { label: 'Insurance (ZERO DEP + Hydrostatic Cover)', leaseCol: 'true', loanCol: '₹45,489', },
        { label: 'Service & Maintenance', leaseCol: 'true', loanCol: '₹47,444', },
        { label: 'Resale Value', leaseCol: 'Factored-in', loanCol: '₹7,29,600', },
        { label: 'GST', leaseCol: 'true', loanCol: 'NA', },
        { label: 'Monthly Lease Cost', leaseCol: '₹55,600', loanCol: '-', },
        { label: 'Tax Benefit (30%)', leaseCol: '₹16,500', loanCol: '-', },
        { label: 'Driver & Fuel Allowance Tax Benefit', leaseCol: '₹15,000', loanCol: '-', },
        { label: 'Monthly Cost', leaseCol: '₹23,500', loanCol: '₹56,433', },
      ],
      footer: {
        footerLine: '58.4%',
      },
    },
    {
      header: {
        bodyType: 'Luxury',
      },
      table: [
        { label: 'Market Price', leaseCol: 'true', loanCol: '₹28,50,000', },
        { label: 'Down payment (20%)', leaseCol: 'true', loanCol: '₹5,70,000', },
        { label: 'EMI (monthly)', leaseCol: 'true', loanCol: '₹-111,636', },
        { label: 'Opportunity Cost on Down Payment (10%)', leaseCol: 'true', loanCol: '₹79,800', },
        { label: 'Insurance (ZERO DEP + Hydrostatic Cover)', leaseCol: 'true', loanCol: '₹2,25,558', },
        { label: 'Service & Maintenance', leaseCol: 'true', loanCol: '₹4,50,872', },
        { label: 'Resale Value', leaseCol: 'Factored-in', loanCol: '₹12,25,500', },
        { label: 'GST', leaseCol: 'true', loanCol: 'NA', },
        { label: 'Monthly Lease Cost', leaseCol: '₹1,35,112', loanCol: '-', },
        { label: 'Tax Benefit (30%)', leaseCol: '₹40,534', loanCol: '-', },
        { label: 'Driver & Fuel Allowance Tax Benefit', leaseCol: '₹15,000', loanCol: '-', },
        { label: 'Monthly Cost', leaseCol: '₹79,578', loanCol: '₹1,15,833', },
      ],
      footer: {
        footerLine: '31.3%',
      },
    },
  ];
  selectedElement = this.comparisonTable[AppConstants.ONE];
 
  faCheck = faCheck;
  faTimes = faTimes;

  constructor(
    private _router: Router,
    private _$gaService: GoogleAnalyticsService
  ) { }

  navigateTo() {
    this._$gaService.event('click_browse_car', 'ga_directive_test');
    this._router.navigate(['cars',], {
      queryParams: {},
      queryParamsHandling: 'merge',
    });
  }

  onHeaderClick(index: number) {
    this.selectedElement = this.comparisonTable[index];
  }

}
